import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { FileTextIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { useAPInvoice } from '@/api/rpc/hooks/accounts-payable/useAPInvoices';

interface APInvoiceInlineProps {
  entityType: SystemEntity; // required by registry; type is AP_INVOICE
  entityId: string;
  className?: string;
}

export function APInvoiceInline({ entityId, className }: APInvoiceInlineProps) {
  const { invoice: invoiceResponse, isLoading } = useAPInvoice(entityId);
  const invoice = invoiceResponse?.invoice;

  const displayName = isLoading
    ? 'Loading...'
    : invoice
      ? `Invoice ${invoice.invoiceNumber}`
      : 'Invoice';

  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <div className="inline-block max-w-full">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer max-w-full', className)}
          >
            <FileTextIcon className="size-3 shrink-0" />
            <span className="truncate">{displayName}</span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.AP_INVOICE}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
